import Image from 'next/image'
import { FounderProps } from '@interfaces/aboutUs'
import { useElementVisible } from '@hooks/useElementVisible'
import styles from './Leadership.module.scss'

export const Founder = ({ founder }: FounderProps) => {
  const founderCard = useElementVisible({ threshold: 0.1 })

  return (
    <div
      ref={founderCard.ref}
      className={`${styles.founderCard} ${founderCard.isVisible ? styles.fadeInAnimation : ''}`}>
      <Image
        src={founder.founderImageUrl}
        alt={`${founder.founderName}-image`}
        width={320}
        height={320}
        className={styles.leaderImage}
      />
      <div className={styles.founderDetails}>
        <p className={styles.founderName}>{founder.founderName}</p>
        <p className={styles.founderTitle}>{founder.founderTitle}</p>
      </div>
    </div>
  )
}
